import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { Reveal } from "../Reveal";

export default function AboutTeaser() {
    return (
        <section data-testid="about-teaser-section" className="py-28 lg:py-36 bg-white">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                    <div className="lg:col-span-7">
                        <Reveal>
                            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-green">
                                <span className="text-slate-400">12&nbsp;&nbsp;·&nbsp;&nbsp;</span>About Us
                            </p>
                        </Reveal>
                        <Reveal delay={0.1}>
                            <h2 className="mt-5 font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.1] text-brand-blue">
                                Built from India. <span className="text-brand-green">Designed for the world.</span>
                            </h2>
                        </Reveal>
                        <Reveal delay={0.2}>
                            <p className="mt-6 max-w-2xl text-base md:text-lg leading-relaxed text-slate-600" data-testid="about-teaser-body">
                                GoMedVoyage was founded with a simple belief: accessing healthcare across borders should not
                                require patients and families to navigate a maze of disconnected providers, paperwork,
                                communication channels and travel arrangements.
                            </p>
                        </Reveal>
                        <Reveal delay={0.3}>
                            <Link
                                data-testid="about-teaser-link"
                                to="/about"
                                className="mt-8 inline-flex items-center gap-2 font-heading text-sm font-semibold text-brand-blue hover:text-brand-green transition-colors duration-200"
                            >
                                Read our story
                                <ArrowRight size={16} weight="bold" />
                            </Link>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-5">
                        <Reveal delay={0.25}>
                            <img
                                src="https://images.pexels.com/photos/7578797/pexels-photo-7578797.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                                alt="Healthcare professional reviewing a patient chart"
                                loading="lazy"
                                className="rounded-[1.75rem] w-full h-[380px] object-cover shadow-[0_24px_60px_rgb(10,37,64,0.12)]"
                                data-testid="about-teaser-image"
                            />
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
}
